import { Box, Typography } from '@mui/material';

interface SettingRowProps {
  label: string;
  description?: string | React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const SettingRow: React.FC<SettingRowProps> = ({ label, description, children, className }) => {
  return (
    <Box className={`flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 my-3 ${className || ''}`}>
      {/* Label and description */}
      <Box className="text-center sm:text-left flex-1">
        <Typography variant="h4">{label}</Typography>
        {description && (
          typeof description === 'string' ? (
            <Typography variant="body14" className="text-gray-600 mt-1">
              {description}
            </Typography>
          ) : (
            <Box>{description}</Box>
          )
        )}
      </Box>

      {/* Control (button, switch, dropdown, etc.) */}
      <Box className="flex justify-center sm:justify-end items-center">{children}</Box>
    </Box>
  );
};

export default SettingRow;
